module.exports = __webpack_public_path__ + "img/james.6955493f.jpg";